import React from 'react';
import ConfirmDeliveryModal from './modals/ConfirmDeliveryModal';
import ConfirmReturnDeliveryModal from './modals/ConfirmReturnDeliveryModal';
import CancelGroupModal from './modals/CancelGroupModal';
import MerchantCancelGroupModal from './modals/MerchantCancelGroupModal';
import RequestGroupReturnModal from './modals/RequestGroupReturnModal';
import CancelGroupReturnModal from './modals/CancelGroupReturnModal';
import TrackingModal from './modals/TrackingModal';
import ApproveAllReturnsModal from './modals/ApproveAllReturnsModal';
import RejectAllReturnsModal from './modals/RejectAllReturnsModal';
import ProcessReturnRequestsModal from './modals/ProcessReturnRequestsModal';
// Import other modals as needed
// import GroupReturnModal from './modals/GroupReturnModal';

const ActionModalRenderer = ({ activeModals = {} }) => {
  const renderModal = (modalId, modalData) => {
    const { component, entity, onConfirm, onCancel, isLoading } = modalData;

    switch (component) {
      case 'ConfirmDeliveryModal':
        return (
          <ConfirmDeliveryModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );
      
      case 'ConfirmReturnDeliveryModal':
        return (
          <ConfirmReturnDeliveryModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );
      
      case 'CancelGroupModal':
        return (
          <CancelGroupModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );

      case 'MerchantCancelGroupModal':
        return (
          <MerchantCancelGroupModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );

      case 'RequestGroupReturnModal':
        return (
          <RequestGroupReturnModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );

      case 'CancelGroupReturnModal':
        return (
          <CancelGroupReturnModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );

      case 'TrackingModal':
        return (
          <TrackingModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            entity={entity}
          />
        );

      case 'ApproveAllReturnsModal':
        return (
          <ApproveAllReturnsModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );

      case 'RejectAllReturnsModal':
        return (
          <RejectAllReturnsModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );

      case 'ProcessReturnRequestsModal':
        return (
          <ProcessReturnRequestsModal
            key={modalId}
            isOpen={true}
            onClose={onCancel}
            onConfirm={onConfirm}
            entity={entity}
            isLoading={isLoading}
          />
        );
      
      // Add more modal cases as needed
      // case 'CancelGroupModal':
      //   return (
      //     <CancelGroupModal
      //       key={modalId}
      //       isOpen={true}
      //       onClose={onCancel}
      //       onConfirm={onConfirm}
      //       entity={entity}
      //     />
      //   );
      
      default:
        console.warn(`Unknown modal component: ${component}`);
        return null;
    }
  };

  return (
    <>
      {Object.entries(activeModals).map(([modalId, modalData]) => 
        renderModal(modalId, modalData)
      )}
    </>
  );
};

export default ActionModalRenderer; 